import Constants from 'expo-constants';

type Stage = 'dev' | 'prod';

const stage = (Constants.manifest?.extra?.stage as Stage) || 'dev';

const globalConfig = {
  termsOfServiceUrl: 'https://monei.com/terms-of-service',
  privacyPolicyUrl: 'https://monei.com/privacy-policy',
  testingUrl: 'https://docs.monei.com/docs/testing/',
  supportEmail: 'support@monei.com',
  supportUrl: 'https://support.monei.com',
  docsUrl: 'https://docs.monei.com',
  secureWebOrigin: 'https://secure.monei.com'
};

const stageConfig = {
  dev: {
    production: false,
    region: 'eu-west-1',
    maxBalance: 100000, // 1000 EURM
    apiEndpoint: 'https://x6gymhl5i5fxvkondr6hsjnbai.appsync-api.eu-west-1.amazonaws.com/graphql',
    identityPoolId: 'eu-west-1:fa8a4c54-8e1a-4ffc-b1de-c33df4485374',
    userPoolId: 'eu-west-1_70X6yqMZ3',
    userPoolWebClientId: '76dtjt3aqo3b2rvnb732lhqadl',
    paymentPagePreviewUrl: 'https://mo-js.microapps-staging.com/v1/payment-page/',
    hostedPaymentDomain: 'secure.microapps-staging.com',
    dashboardUrl: 'https://mo.microapps-staging.com',
    signUpUrl: 'https://mo.microapps-staging.com?action=signUp&from_mobile=1',
    explorerUrl: 'https://www.oklink.com/amoy'
  },
  prod: {
    production: true,
    region: 'eu-west-1',
    maxBalance: 1000, // 10 EURM
    apiEndpoint: 'https://m3qhbmrswbeupdtlkslpgpv7na.appsync-api.eu-west-1.amazonaws.com/graphql',
    identityPoolId: 'eu-west-1:75d598b7-e98e-4cf8-a1f6-9620ee0abca8',
    userPoolId: 'eu-west-1_d9TqcSvUB',
    userPoolWebClientId: '6f04443m8mpn4f04hql2n3hbt8',
    paymentPagePreviewUrl: 'https://js.monei.com/v1/payment-page/',
    hostedPaymentDomain: 'secure.monei.com',
    dashboardUrl: 'https://dashboard.monei.com',
    signUpUrl: 'https://dashboard.monei.com?action=signUp&from_mobile=1',
    explorerUrl: 'https://polygonscan.com'
  }
};

export const config = {...globalConfig, ...stageConfig[stage]};
